import { Capacitor } from '@capacitor/core'
import { AppUpdate } from '@capawesome/capacitor-app-update'
import { useEffect, useState } from 'react'

const useAppUpdates = () => {
	const [updateAvailable, setUpdateAvailable] = useState(false)

	const getVersionInfo = async () => {
		const result = await AppUpdate.getAppUpdateInfo()
		const isAndroid = Capacitor.getPlatform() === 'android'
		return {
			current: isAndroid ? result.currentVersionCode : result.currentVersionName,
			available: isAndroid ? result.availableVersionCode : result.availableVersionName,
		}
	}

	const checkAndPromptUpdate = async () => {
		if (Capacitor.getPlatform() === 'web') return
		const { current, available } = await getVersionInfo()
		if (current !== available) {
			if (window.confirm(`Uusi versio saatavilla: ${available}. Haluatko päivittää?`)) {
				AppUpdate.openAppStore()
			}
		}
	}

	useEffect(() => {
		if (Capacitor.getPlatform() === 'web') return
		getVersionInfo()
			.then(({ current, available }) => {
				if (current !== available) setUpdateAvailable(true)
			})
			.catch(() => {
				console.warn('Failed to check for app updates')
			})
	}, [])

	return { updateAvailable, checkAndPromptUpdate }
}
export default useAppUpdates
